import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import { f as o } from "../internals/function-uncurry-this.js";
import { r as n } from "../internals/require-object-coercible.js";
import { t as i } from "../internals/to-string.js";
import { f as e } from "../internals/fails.js";
var a = Array,
  s = o("".charAt),
  f = o("".charCodeAt),
  l = o([].join),
  m = "".toWellFormed,
  c = m && e(function () {
    return "1" !== t(m, 1);
  });
r({
  target: "String",
  proto: !0,
  forced: c
}, {
  toWellFormed: function toWellFormed() {
    var r = i(n(this));
    if (c) return t(m, r);
    for (var o = r.length, e = a(o), u = 0; u < o; u++) {
      var j = f(r, u);
      (63488 & j) != 55296 ? e[u] = s(r, u) : j >= 56320 || u + 1 >= o || (64512 & f(r, u + 1)) != 56320 ? e[u] = "�" : (e[u] = s(r, u), e[++u] = s(r, u));
    }
    return l(e, "");
  }
});